import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface QuickRecipeFormData {
  title: string;
  servings: string;
  instructions: string;
  imageUrl?: string;
  userImageUrl?: string;
  userImagePath?: string;
}

interface QuickRecipeFormFieldsProps {
  formData: QuickRecipeFormData;
  setFormData: React.Dispatch<React.SetStateAction<QuickRecipeFormData>>;
}

const QuickRecipeFormFields: React.FC<QuickRecipeFormFieldsProps> = ({
  formData,
  setFormData
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="title">Recipe Title *</Label>
          <Input
            id="title"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            placeholder="e.g., Grilled Chicken & Broccoli"
            enterKeyHint="next"
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="servings">Servings</Label>
          <Input
            id="servings"
            value={formData.servings}
            onChange={(e) => setFormData({ ...formData, servings: e.target.value })}
            placeholder="4"
            inputMode="numeric"
            enterKeyHint="next"
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="instructions">Instructions (Optional)</Label>
        <Textarea
          id="instructions"
          value={formData.instructions}
          onChange={(e) => setFormData({ ...formData, instructions: e.target.value })}
          placeholder="Brief cooking instructions..."
          enterKeyHint="done"
          className="mt-1"
        />
      </div>
    </>
  );
};

export default QuickRecipeFormFields;
